var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pick-background-color"},[_c('Compact',{staticClass:"default-color-list",attrs:{"value":_vm.color},on:{"input":_vm.changeBackgrounColor}}),_c('Chrome',{staticClass:"color-picker",attrs:{"value":_vm.color},on:{"input":_vm.changeBackgrounColor}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }